import React, { createRef, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import SpButton from "../../../../components/atoms/SpButton";
import { withSnackbar } from "../../../../components/atoms/SpSnackBar";
import SpText from "../../../../components/atoms/SpText";
import {
  getAssessmentMonitoringAnswers,
  getAssessmentPresentationAnswers,
} from "../../../../models/actions/Assessment";

import { labels, psTranslate } from "../../../shared/translations";
import { theme } from "../../../../components/theme";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const AssessmentDetails = ({
  assessmentDetail,
  setLoading,
  close,
  ...props
}) => {
  const [currentAssessments, setCurrentAssessments] = useState();
  const { presentationId, patId } = useParams();

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = presentationId
        ? await getAssessmentPresentationAnswers({
            id_presentation_assessment: assessmentDetail.id,
            id_patient: patId,
          })
        : await getAssessmentMonitoringAnswers({
            id_test: assessmentDetail.id,
            id_patient: patId,
          });

      setCurrentAssessments(response);
    } catch (error) {
      props.snackbarShowErrorMessage(error);
    }
    setLoading(false);
  };

  const download = async () => {
    const { sequences, questions } = currentAssessments;
    const sortedQuestions = [...questions].sort((a, b) => a.id - b.id);
    // Costruzione intestazione: prima cella vuota per il nome della domanda, poi le date
    const header = ["Question", ...sequences.map((seq) => seq.date)];

    // Costruzione righe: ogni riga ha il nome della domanda + le risposte
    const rows = sortedQuestions.map((question) => {
      const row = [psTranslate(question.name)];

      sequences.forEach((seq) => {
        const answerObj = seq.test_answers.find(
          (ans) => ans.test_question.id === question.id
        );
        row.push(answerObj?.answer ?? "-");
      });

      return row;
    });

    const worksheetData = [header, ...rows];
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Risposte");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, assessmentDetail.name + ".xlsx");
  };

  useEffect(fetchData, []);

  const TestTable = ({ data }) => {
    const { sequences, questions } = data;
    const sortedQuestions = [...questions].sort((a, b) => a.id - b.id);
    const tabelStyle = {
      border: "2px solid " + theme.colors.primary.lightBlue,
    };
    return (
      <div
        style={{
          width: "90vw",
          height: "100vh",
          overflow: "auto",
        }}
      >
        <table style={{ borderCollapse: "collapse", minWidth: "100%" }}>
          <thead style={tabelStyle}>
            <tr style={tabelStyle}>
              <th
                style={{
                  position: "sticky",
                  left: 0,
                  backgroundColor: "#000",
                  zIndex: 2,
                  ...tabelStyle,
                }}
              ></th>
              {sequences.map((seq) => (
                <th key={seq.id} style={tabelStyle}>
                  <SpText
                    variant="h1PageTitleDialogColored"
                    style={{ padding: "0.5rem" }}
                  >
                    {seq.date}
                  </SpText>
                </th>
              ))}
            </tr>
          </thead>
          <tbody style={tabelStyle}>
            {sortedQuestions.map((question) => (
              <tr key={question.id} style={tabelStyle}>
                <td
                  style={{
                    position: "sticky",
                    left: 0,
                    backgroundColor: "#000",
                    zIndex: 1,
                    ...tabelStyle,
                  }}
                >
                  <SpText
                    variant="textWhiteArchivedBold"
                    style={{ padding: "0.5rem" }}
                  >
                    {psTranslate(question.name)}
                    {question?.um ? " [" + question?.um + "]" : ""}
                  </SpText>
                </td>
                {sequences.map((seq) => {
                  const answerObj = seq.test_answers.find(
                    (ans) => ans.test_question.id == question.id
                  );

                  return (
                    <td key={seq.id} style={tabelStyle}>
                      <SpText
                        variant="textWhiteArchivedBold"
                        style={{ padding: "0.5rem" }}
                      >
                        {answerObj?.answer ?? "-"}
                      </SpText>
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <>
      <SpButton
        buttonType="accept"
        style={{ maxWidth: "25%", marginBottom: "10px" }}
        onClick={() => close()}
        text={labels.patient.monitoring.closeAddAssessment}
      />
      <SpButton
        buttonType="accept"
        style={{ maxWidth: "25%", marginBottom: "10px" }}
        onClick={() => {
          download();
        }}
        text={"download excel"}
      />
      {currentAssessments && (
        <TestTable data={currentAssessments ? currentAssessments : {}} />
      )}
    </>
  );
};

export default withSnackbar(AssessmentDetails);
